import { __values } from "tslib";
import { defineComponent } from 'vue';
import * as common from 'tree-component';
export * from 'tree-component';
import { nodeTemplateHtml, treeTemplateHtml } from './variables';
/**
 * @public
 */
export var Node = defineComponent({
    props: {
        data: {
            type: Object,
            required: true,
        },
        last: {
            type: Boolean,
            required: true,
        },
        checkbox: Boolean,
        path: {
            type: Array,
            required: true,
        },
        draggable: {
            type: Boolean,
            required: true,
        },
        root: Array,
        zindex: Number,
        preid: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            contextmenuVisible: false,
            hovered: false,
            doubleClick: new common.DoubleClick(),
        };
    },
    computed: {
        contextmenuStyle: function () {
            return {
                'position': 'absolute',
                'left': '0px',
                'top': '0px',
                'z-index': typeof this.zindex === 'number' ? this.zindex : 1
            };
        },
        nodeClassName: function () {
            var hasChildren = typeof this.$slots.default === 'function' ? this.$slots.default().length > 0 : !!this.$slots.default;
            return common.getNodeClassName(this.data, this.last, hasChildren);
        },
        anchorClassName: function () {
            return common.getAnchorClassName(this.data, this.hovered, this.path);
        },
        checkboxClassName: function () {
            return common.getCheckboxClassName(this.data, this.path);
        },
        iconClassName: function () {
            return common.getIconClassName(this.data.icon);
        },
        oclClassName: function () {
            return common.getOclClassName(this.path);
        },
        pathString: function () {
            return this.path.toString();
        },
        hasMarker: function () {
            return this.draggable && this.data.state.dropPosition !== 0 /* empty */;
        },
        markerClassName: function () {
            return common.getMarkerClassName(this.data);
        },
        eventData: function () {
            return {
                data: this.data,
                path: this.path
            };
        },
        id: function () {
            return common.getId(this.path, this.preid);
        }
    },
    methods: {
        geChildPath: function (index) {
            return this.path.concat(index);
        },
        hover: function (hovered) {
            this.hovered = hovered;
            if (!hovered) {
                this.contextmenuVisible = false;
            }
        },
        ontoggle: function (eventData) {
            if (eventData) {
                this.$emit('toggle', eventData);
            }
            else {
                if (this.data.state.openable || this.data.children.length > 0 || this.$slots.default) {
                    this.$emit('toggle', this.eventData);
                }
            }
        },
        onchange: function (eventData) {
            var _this = this;
            if (eventData) {
                this.$emit('change', eventData);
            }
            else {
                if (this.data.state.disabled) {
                    return;
                }
                this.doubleClick.onclick(function () {
                    _this.$emit('change', _this.eventData);
                });
            }
        },
        oncontextmenu: function (e) {
            this.contextmenuVisible = true;
            this.contextmenuStyle.left = e.offsetX + 'px';
            this.contextmenuStyle.top = e.offsetY + 'px';
            e.preventDefault();
            return false;
        },
        ondragstart: function (event) {
            this.$emit('dragstart', event);
        },
        ondragend: function (event) {
            this.$emit('dragend', event);
        },
        ondragover: function (event) {
            this.$emit('dragover', event);
        },
        ondragenter: function (event) {
            this.$emit('dragenter', event);
        },
        ondragleave: function (event) {
            this.$emit('dragleave', event);
        },
        ondrop: function (event) {
            this.$emit('drop', event);
        },
    },
    render: nodeTemplateHtml,
});
/**
 * @public
 */
export var Tree = defineComponent({
    render: treeTemplateHtml,
    props: {
        data: {
            type: Array,
            required: true,
        },
        checkbox: Boolean,
        draggable: Boolean,
        nodots: Boolean,
        size: String,
        theme: String,
        dropAllowed: Function,
        zindex: Number,
        preid: String,
        dragTarget: Object,
    },
    data: function () {
        return {
            localDragTarget: null,
            dropTarget: null,
        };
    },
    computed: {
        rootClassName: function () {
            return common.getRootClassName(this.checkbox, this.size, this.theme);
        },
        containerClassName: function () {
            return common.getContainerClassName(this.nodots);
        }
    },
    methods: {
        ontoggle: function (eventData) {
            this.$emit('toggle', eventData);
        },
        onchange: function (eventData) {
            this.$emit('change', eventData);
        },
        ondragstart: function (event) {
            if (!this.draggable) {
                return;
            }
            this.localDragTarget = event.target;
            this.dropTarget = event.target;
            this.$emit('change-drag-target', {
                target: event.target,
                root: this.data
            });
        },
        ondragend: function (event) {
            var e_1, _a;
            if (!this.draggable) {
                return;
            }
            this.localDragTarget = null;
            try {
                for (var _b = __values(this.data), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var tree = _c.value;
                    common.clearMarkerOfTree(tree);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.$emit('change-drag-target', null);
        },
        ondragover: function (event) {
            if (!this.canDrop(event)) {
                return;
            }
            if (this.dragTarget) {
                common.ondrag(event.pageY, this.dragTarget.target, this.dropTarget, this.dragTarget.root, this.data, this.dropAllowed);
            }
            else {
                common.ondrag(event.pageY, this.localDragTarget, this.dropTarget, this.data, this.data, this.dropAllowed);
            }
            event.preventDefault();
        },
        ondragenter: function (event) {
            if (!this.canDrop(event)) {
                return;
            }
            this.dropTarget = this.getAnchor(event.target);
            if (this.dragTarget) {
                common.ondrag(event.pageY, this.dragTarget.target, this.dropTarget, this.dragTarget.root, this.data, this.dropAllowed);
            }
            else {
                common.ondrag(event.pageY, this.localDragTarget, this.dropTarget, this.data, this.data, this.dropAllowed);
            }
        },
        ondragleave: function (event) {
            if (!this.canDrop(event)) {
                return;
            }
            var target = this.getAnchor(event.target);
            var containsTarget = this.containsNode(this.dropTarget, event.target);
            if (!containsTarget && target === this.dropTarget) {
                this.dropTarget = null;
            }
            common.ondragleave(target, this.data);
        },
        ondrop: function (event) {
            var _this = this;
            if (!this.canDrop(event)) {
                return;
            }
            if (this.dragTarget) {
                common.ondrop(this.getAnchor(event.target), this.dragTarget.target, this.dragTarget.root, this.data, function (dropData) {
                    _this.$emit('drop', dropData);
                });
            }
            else {
                common.ondrop(this.getAnchor(event.target), this.localDragTarget, this.data, this.data, function (dropData) {
                    _this.$emit('drop', dropData);
                });
            }
        },
        canDrop: function (event) {
            if (!this.draggable || !event.target) {
                return false;
            }
            var hasPath = event.target.dataset && event.target.dataset.path;
            if (!hasPath && event.target.classList && !event.target.classList.contains('tree-node')) {
                var target = this.getAnchor(event.target);
                return target.dataset && target.dataset.path;
            }
            return hasPath;
        },
        containsNode: function (parentNode, node) {
            for (var i = 0; i < parentNode.children.length; i++) {
                var child = parentNode.children[i];
                if (child === node) {
                    return true;
                }
                if (child.children) {
                    return this.containsNode(child, node);
                }
            }
            return false;
        },
        getAnchor: function (target) {
            var anchor = target;
            while (anchor && anchor.classList && !anchor.classList.contains('tree-anchor')) {
                anchor = anchor.parentElement;
            }
            if (anchor && anchor.classList && anchor.classList.contains('tree-anchor')) {
                return anchor;
            }
            return target;
        }
    }
});
